var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToList = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M9.375 15.15a.45.45 0 0 1 .45-.45H12.9a.45.45 0 1 1 0 .9H9.825a.45.45 0 0 1-.45-.45m0-2.1a.45.45 0 0 1 .45-.45H14.4a.45.45 0 0 1 0 .9H9.825a.45.45 0 0 1-.45-.45m0-2.1a.45.45 0 0 1 .45-.45h4.35a.45.45 0 0 1 0 .9h-4.35a.45.45 0 0 1-.45-.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M16.5 6.75h-2.895a1.576 1.576 0 0 0-3.06 0H7.5A1.5 1.5 0 0 0 6 8.25v8.25A1.5 1.5 0 0 0 7.5 18h5.4-.15.16a.45.45 0 0 0-.01-.9H7.5a.6.6 0 0 1-.6-.6V8.25a.6.6 0 0 1 .6-.6h1.125v.6c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75v-.6H16.5a.6.6 0 0 1 .6.6v3.525a.45.45 0 1 0 .9 0V8.25a1.5 1.5 0 0 0-1.5-1.5m-4.425.9a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M18.375 16.125a.263.263 0 0 0-.262-.262h-.6v-.6a.262.262 0 1 0-.526 0v.6h-.6a.26.26 0 0 0-.262.26v.002c0 .145.118.263.262.263h.6v.6c0 .144.117.261.26.262h.003a.263.263 0 0 0 .262-.262v-.6h.6a.263.263 0 0 0 .263-.263"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M19.5 16.125a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.25 1.688a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-to-list.a7706b9a.svg";